import { Component, input } from '@angular/core';
import { HeatstressDetectedForCustomerNotificationDto } from 'src/app/tga/shared/models/models';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-heatstress-detected-for-customer-body',
    templateUrl: './heatstress-detected-for-customer-body.component.html',
    styleUrls: ['./heatstress-detected-for-customer-body.component.scss'],
    imports: [TranslatePipe],
})
export class HeatstressDetectedForCustomerBodyComponent {
  notification = input.required<HeatstressDetectedForCustomerNotificationDto>();
}
